import { AuthOptions } from 'domains/Session/components'
import { PageWrapper } from '@qonsoll/react-design'
import { useTranslations } from '@qonsoll/translation'

const SignIn = () => {
  const { t } = useTranslations()
  const headingProps = {
    title: t('Send tip - get rewards'),
    titleSize: 3,
    marginBottom: 4,
    textAlign: 'center'
  }

  return (
    <PageWrapper
      headingProps={headingProps}
      alignMiddle
      contentWidth={['100%', '100%', 400]}>
      <AuthOptions isLogin={true} />
    </PageWrapper>
  )
}

export default SignIn
